import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { generateBackup } from '@/utils/backupUtil';
let AdminBackup = class AdminBackup extends Vue {
    isLoading = false;
    error = null;
    lastBackupTimestamp = null;
    showSuccess = false;
    get isAdmin() {
        return this.$store.getters['user/isAdmin'];
    }
    async handleDownload() {
        this.isLoading = true;
        this.error = null;
        try {
            const result = await generateBackup();
            if (result.success) {
                this.lastBackupTimestamp = result.timestamp || null;
                this.showSuccess = true;
            }
            else {
                this.error = result.error || 'Neznámá chyba při vytváření zálohy';
            }
        }
        catch (e) {
            this.error = e instanceof Error ? e.message : 'Chyba při stahování zálohy';
        }
        finally {
            this.isLoading = false;
        }
    }
    clearError() {
        this.error = null;
    }
    formatTimestamp(timestamp) {
        return new Date(timestamp).toLocaleString('cs-CZ');
    }
};
AdminBackup = __decorate([
    Component
], AdminBackup);
export default AdminBackup;
